interface SubscriptionClientBackoff {
    attempts: number;
    reset: () => void;
    duration: () => number;
}

const MAX_ATTEMPTS = 4;
const SECOND = 1000;

export class DocumentFocusBackoff implements SubscriptionClientBackoff {
    attempts = 0;

    private focusedMin = 0.1 * SECOND;
    private focusedMax = 10 * SECOND;
    private unfocusedMin = 10 * SECOND;
    private unfocusedMax = 120 * SECOND;

    // Return the backoff duration
    duration() {
        if (this.attempts === 0) {
            this.attempts = this.attempts + 1;

            if (document && document.hasFocus()) {
                return this.initialDuration(this.focusedMin, this.focusedMax);
            }
            return this.initialDuration(this.unfocusedMin, this.unfocusedMax);
        }

        if (this.attempts < MAX_ATTEMPTS) {
            this.attempts = this.attempts + 1;
        }

        return Math.pow(this.attempts, 4) * SECOND;
    }

    initialDuration(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    // Reset the number of attempts
    reset() {
        this.attempts = 0;
    }
}
export default DocumentFocusBackoff;
